import { EnvTypes } from "myria-core-sdk";

const env = EnvTypes.PRODUCTION;
const accessKeyId = "AKIAWFBB5VYXXVN46FNO";
const secretAccessKey = "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";
const bucketName = `admin-tools-assets-${env}`;
const region = "us-east-1";

export { env, accessKeyId, secretAccessKey, bucketName, region };
